<template>
  <div id="index">
    <div style="text-align:left;padding-left:10px;">
      １．登録内容の確認
    </div>
    <user-profile-edit
      @onSend="onSend"
      @onMessage='onMessage'
      mode='init'
    ></user-profile-edit>
    <p>プロフィールはマイページから変更できます</p>
  </div>
</template>

<script>
import UserProfileEdit from '@/components/form/UserProfileEditForm.vue'

// @ is an alias to /src
export default {
  name: 'MyPageTop',
  data () {
    return {
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  filters: {
  },
  created () {
  },
  methods: {
    onSend () {
      // MyPageへ
      this.$router.push({name: 'karasaInit'})
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    }
  },
  components: {
    UserProfileEdit
  },
  head: {
    title () {
      return {
        inner: 'ユーザー情報の初期登録',
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '激辛口コミグルメサイトの初期登録ページです'}
      ]
    },
    link () {
      return [
        {rel: 'canonical', href: 'https://karaiine.jp/'}
      ]
    }
  }
}
</script>

<style scoped>
  #index{
    min-height:90vh;
    text-align:center;
  }
</style>
>